import React, { useState, useEffect } from 'react';
import { useAuth, axios } from '../context/AuthContext';
import toast from 'react-hot-toast';
import DersProgramiIceAktar from '../components/settings/DersProgramiIceAktar';
import { ADMIN_PANEL_ROLES } from '../config/accessControl';

export default function AyarlarPage() {
  const { user, fetchMe } = useAuth();
  const [profilForm, setProfilForm] = useState({
    ad: user?.ad || '', soyad: user?.soyad || '', telefon: user?.telefon || '',
  });

  const parseEmail = (emailStr = '') => {
    if (!emailStr || !emailStr.includes('@')) {
      return { prefix: emailStr || '', domain: '@asdersistem.com' };
    }
    const atIndex = emailStr.indexOf('@');
    return {
      prefix: emailStr.slice(0, atIndex),
      domain: emailStr.slice(atIndex),
    };
  };

  const [emailPrefix, setEmailPrefix] = useState(() => parseEmail(user?.email).prefix);
  const emailDomain = parseEmail(user?.email).domain;

  const [sifreForm, setSifreForm] = useState({ eski_sifre: '', yeni_sifre: '', tekrar: '' });
  const [loadingProfil, setLoadingProfil] = useState(false);
  const [loadingSifre, setLoadingSifre] = useState(false);
  const [hedefForm, setHedefForm] = useState({ hedef_net: '', hedef_puan: '', sinav_turu: 'TYT' });
  const [loadingHedef, setLoadingHedef] = useState(false);

  useEffect(() => {
    if (user) {
      setProfilForm({
        ad: user.ad || '',
        soyad: user.soyad || '',
        telefon: user.telefon || '',
      });
      setEmailPrefix(parseEmail(user.email).prefix);
    }
  }, [user]);

  useEffect(() => {
    if (user?.rol === 'ogrenci') {
      axios.get('/ogrenciler').then(res => {
        const me = (res.data?.data || []).find(item => item.user_id === user.id) || res.data?.data?.[0];
        if (me) setHedefForm({
          hedef_net: me.hedef_net ?? '',
          hedef_puan: me.hedef_puan ?? '',
          sinav_turu: me.sinav_turu || 'TYT',
        });
      }).catch(() => {});
    }
  }, [user]);

  const handleHedefSave = async () => {
    setLoadingHedef(true);
    try {
      await axios.put('/ogrenciler/hedef', hedefForm);
      await fetchMe();
      toast.success('Hedef güncellendi! 🎯');
    } catch { toast.error('Güncelleme hatası'); }
    finally { setLoadingHedef(false); }
  };

  const handleProfilSave = async () => {
    if (!emailPrefix.trim()) {
      toast.error('E-posta kullanıcı adı boş bırakılamaz');
      return;
    }
    setLoadingProfil(true);
    try {
      const res = await axios.put('/auth/profil-guncelle', {
        ...profilForm,
        email_prefix: emailPrefix.trim(),
      });
      await fetchMe();
      toast.success(res.data?.message || 'Profil güncellendi!');
    } catch (e) {
      toast.error(e.response?.data?.message || 'Güncelleme başarısız');
    } finally {
      setLoadingProfil(false);
    }
  };

  const handleSifreDegistir = async () => {
    if (sifreForm.yeni_sifre !== sifreForm.tekrar) {
      toast.error('Şifreler eşleşmiyor'); return;
    }
    if (sifreForm.yeni_sifre.length < 6) {
      toast.error('Şifre en az 6 karakter olmalı'); return;
    }
    setLoadingSifre(true);
    try {
      await axios.put('/auth/sifre-degistir', {
        eski_sifre: sifreForm.eski_sifre,
        yeni_sifre: sifreForm.yeni_sifre,
      });
      setSifreForm({ eski_sifre: '', yeni_sifre: '', tekrar: '' });
      toast.success('Şifre değiştirildi!');
    } catch (e) {
      toast.error(e.response?.data?.message || 'Şifre değiştirilemedi');
    }
    finally { setLoadingSifre(false); }
  };

  const ROLE_COLORS = {
    kurucu: 'var(--accent)', ogrenci_isleri: '#10B981', ogretmen: '#3B82F6',
    rehber_ogretmen: '#8B5CF6', veli: '#EC4899', ogrenci: '#06B6D4',
  };
  const ROLE_LABELS = {
    kurucu: 'Kurucu / Admin', ogrenci_isleri: 'Öğrenci İşleri',
    ogretmen: 'Öğretmen', rehber_ogretmen: 'Rehber Öğretmen',
    veli: 'Veli', ogrenci: 'Öğrenci',
  };
  const roleColor = ROLE_COLORS[user?.rol] || '#94A3B8';

  return (
    <div style={{ display: 'flex', flexDirection: 'column', gap: 24, maxWidth: 720 }}>
      {/* Profile Card */}
      <div className="card animate-fadeInUp">
        <div style={{ display: 'flex', alignItems: 'center', gap: 20, marginBottom: 28 }}>
          <div className="avatar avatar-xl" style={{ background: roleColor + '22', color: roleColor }}>
            {user?.ad?.[0]}{user?.soyad?.[0]}
          </div>
          <div>
            <h3 style={{ fontFamily: 'var(--font-ui)', marginBottom: 6 }}>{user?.ad} {user?.soyad}</h3>
            <div style={{ display: 'flex', gap: 10, alignItems: 'center' }}>
              <span style={{
                background: roleColor + '18', color: roleColor,
                padding: '3px 10px', borderRadius: 99, fontSize: '0.78rem', fontWeight: 600,
              }}>
                {ROLE_LABELS[user?.rol] || user?.rol}
              </span>
              <span style={{ fontSize: '0.8rem', color: 'var(--text-muted)' }}>{user?.email}</span>
            </div>
          </div>
        </div>

        <div style={{ display: 'grid', gridTemplateColumns: 'repeat(auto-fit, minmax(260px, 1fr))', gap: 16 }}>
          <div className="form-group">
            <label className="form-label">Ad</label>
            <input className="form-input" value={profilForm.ad}
              onChange={e => setProfilForm({...profilForm, ad: e.target.value})} />
          </div>
          <div className="form-group">
            <label className="form-label">Soyad</label>
            <input className="form-input" value={profilForm.soyad}
              onChange={e => setProfilForm({...profilForm, soyad: e.target.value})} />
          </div>
          <div className="form-group">
            <label className="form-label">Telefon</label>
            <input className="form-input" value={profilForm.telefon} type="tel"
              onChange={e => setProfilForm({...profilForm, telefon: e.target.value})} />
          </div>
          <div className="form-group">
            <label className="form-label">E-posta (Kullanıcı Adı)</label>
            <div style={{
              display: 'flex',
              alignItems: 'stretch',
              borderRadius: 8,
              border: '1px solid var(--border, #e2e8f0)',
              background: 'var(--card-bg, #ffffff)',
              overflow: 'hidden',
              boxShadow: '0 1px 2px rgba(0,0,0,0.04)',
            }}>
              <input
                className="form-input"
                style={{
                  border: 'none',
                  borderRadius: 0,
                  flex: 1,
                  minWidth: 0,
                  padding: '9px 12px',
                  boxShadow: 'none',
                  background: 'transparent',
                }}
                value={emailPrefix}
                onChange={e => setEmailPrefix(e.target.value.toLowerCase().replace(/[^a-z0-9._-]/g, ''))}
                placeholder="kullanici.adi"
              />
              <div
                style={{
                  display: 'flex',
                  alignItems: 'center',
                  padding: '0 12px',
                  background: 'var(--bg-elevated, #f1f5f9)',
                  borderLeft: '1px solid var(--border, #e2e8f0)',
                  color: 'var(--text-muted, #64748b)',
                  fontSize: '0.84rem',
                  fontWeight: 700,
                  userSelect: 'none',
                  whiteSpace: 'nowrap',
                  cursor: 'not-allowed',
                }}
                title="Alan adı sabittir ve değiştirilemez"
              >
                🔒 {emailDomain}
              </div>
            </div>
            <div style={{ fontSize: '0.73rem', color: 'var(--text-muted)', marginTop: 4 }}>
              Yalnızca isim bölümünü değiştirebilirsiniz. <strong style={{ color: 'var(--text-primary)' }}>{emailDomain}</strong> uzantısı sabittir.
            </div>
          </div>
        </div>

        <button
          className="btn btn-primary"
          style={{ marginTop: 20 }}
          onClick={handleProfilSave}
          disabled={loadingProfil}
        >
          {loadingProfil ? <><div className="spinner" style={{ width: 16, height: 16 }} /> Kaydediliyor...</> : '💾 Profili Kaydet'}
        </button>
      </div>

      {ADMIN_PANEL_ROLES.includes(user?.rol) && <DersProgramiIceAktar />}

      {user?.rol === 'ogrenci' && (
        <div className="card animate-fadeInUp stagger-1">
          <h3 style={{ fontFamily: 'var(--font-ui)', marginBottom: 20 }}>🎯 Hedeflerim</h3>
          <div style={{ display: 'grid', gridTemplateColumns: 'repeat(auto-fit, minmax(180px, 1fr))', gap: 16 }}>
            <div className="form-group">
              <label className="form-label">Hedef Net</label>
              <input
                className="form-input"
                type="number"
                min="0"
                step="0.25"
                value={hedefForm.hedef_net}
                onChange={e => setHedefForm({ ...hedefForm, hedef_net: e.target.value })}
                placeholder="90"
              />
            </div>
            <div className="form-group">
              <label className="form-label">Hedef Puan</label>
              <input
                className="form-input"
                type="number"
                min="0"
                step="0.01"
                value={hedefForm.hedef_puan}
                onChange={e => setHedefForm({ ...hedefForm, hedef_puan: e.target.value })}
                placeholder="420"
              />
            </div>
            <div className="form-group">
              <label className="form-label">Sınav Türü</label>
              <select
                className="form-input"
                value={hedefForm.sinav_turu}
                onChange={e => setHedefForm({ ...hedefForm, sinav_turu: e.target.value })}
              >
                <option value="TYT">TYT</option>
                <option value="AYT">AYT</option>
                <option value="TYT-AYT">TYT-AYT</option>
                <option value="LGS">LGS</option>
              </select>
            </div>
          </div>

          <div style={{
            marginTop: 16,
            padding: '12px 14px',
            background: 'var(--bg-elevated)',
            border: '1px solid var(--border)',
            borderRadius: 12,
            fontSize: '0.82rem',
            color: 'var(--text-muted)'
          }}>
            Buradan güncellediğin hedef net aynı öğrenci kaydına yazılır. Kurucu, öğrenci işleri ve kendi panelinde aynı değer görünür.
          </div>

          <button
            className="btn btn-primary"
            style={{ marginTop: 20 }}
            onClick={handleHedefSave}
            disabled={loadingHedef}
          >
            {loadingHedef ? <><div className="spinner" style={{ width: 16, height: 16 }} /> Kaydediliyor...</> : '🎯 Hedefi Kaydet'}
          </button>
        </div>
      )}

      {/* Password Change */}
      <div className="card animate-fadeInUp stagger-2">
        <h3 style={{ fontFamily: 'var(--font-ui)', marginBottom: 20 }}>🔐 Şifre Değiştir</h3>
        <div style={{ display: 'flex', flexDirection: 'column', gap: 16, maxWidth: 400 }}>
          {[
            { key: 'eski_sifre', label: 'Mevcut Şifre', placeholder: '••••••••' },
            { key: 'yeni_sifre', label: 'Yeni Şifre', placeholder: 'En az 6 karakter' },
            { key: 'tekrar', label: 'Yeni Şifre (Tekrar)', placeholder: '••••••••' },
          ].map(f => (
            <div className="form-group" key={f.key}>
              <label className="form-label">{f.label}</label>
              <input
                className="form-input"
                type="password"
                placeholder={f.placeholder}
                value={sifreForm[f.key]}
                onChange={e => setSifreForm({...sifreForm, [f.key]: e.target.value})}
              />
            </div>
          ))}
          <button
            className="btn btn-primary"
            onClick={handleSifreDegistir}
            disabled={loadingSifre}
          >
            {loadingSifre ? <><div className="spinner" style={{ width: 16, height: 16 }} /> Değiştiriliyor...</> : '🔄 Şifreyi Değiştir'}
          </button>
        </div>
      </div>

      {/* System Info */}
      <div className="card animate-fadeInUp stagger-3">
        <h3 style={{ fontFamily: 'var(--font-ui)', marginBottom: 16 }}>ℹ️ Sistem Bilgisi</h3>
        <div style={{ display: 'flex', flexDirection: 'column', gap: 12 }}>
          {[
            { label: 'Uygulama', value: 'Dershane Pro v1.0.0' },
            { label: 'Son Giriş', value: user?.son_giris ? new Date(user.son_giris).toLocaleString('tr-TR') : '—' },
            { label: 'Üyelik Tarihi', value: user?.created_at ? new Date(user.created_at).toLocaleDateString('tr-TR') : '—' },
          ].map((item, i) => (
            <div key={i} style={{
              display: 'flex', justifyContent: 'space-between', alignItems: 'center',
              padding: '10px 14px', background: 'var(--bg-elevated)',
              borderRadius: 10, border: '1px solid var(--border)',
            }}>
              <span style={{ fontSize: '0.82rem', color: 'var(--text-muted)' }}>{item.label}</span>
              <span style={{ fontSize: '0.85rem', fontWeight: 500 }}>{item.value}</span>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
}
